var _a, _b, _c;
import { treatInfo as sharedTreatInfo, } from '@content/products/extras';
import beefBlueberryPDP1Src from '@images/marketing/PDPs/BeefBlueberryPage-Carousel-1.jpg';
import beefBlueberryPDP2Src from '@images/marketing/PDPs/BeefBlueberryPage-Carousel-2.jpg';
import beefBlueberryPDP3Src from '@images/marketing/PDPs/BeefBlueberryPage-Carousel-3.jpg';
import beefJerkyPDP1Src from '@images/marketing/PDPs/BeefTreats-Carousel-1.jpg';
import beefJerkyPDP2Src from '@images/marketing/PDPs/BeefTreats-Carousel-2.jpg';
import beefJerkyPDP3Src from '@images/marketing/PDPs/BeefTreats-Carousel-3.jpg';
import chickenCranberryPDP1Src from '@images/marketing/PDPs/ChickenCranberryPage-Carousel-1.jpg';
import chickenCranberryPDP2Src from '@images/marketing/PDPs/ChickenCranberryPage-Carousel-2.jpg';
import chickenCranberryPDP3Src from '@images/marketing/PDPs/ChickenCranberryPage-Carousel-3.jpg';
import chickenJerkyPDP1Src from '@images/marketing/PDPs/ChickenJerkyPage-Carousel-1.jpg';
import chickenJerkyPDP2Src from '@images/marketing/PDPs/ChickenJerkyPage-Carousel-2.jpg';
import chickenJerkyPDP3Src from '@images/marketing/PDPs/ChickenJerkyPage-Carousel-3.jpg';
import fullSpectrumPDP1Src from '@images/marketing/PDPs/FullSpectrumPage-Carousel-1.jpg';
import fullSpectrumPDP2Src from '@images/marketing/PDPs/FullSpectrumPage-Carousel-2.jpg';
import giTargetedPDP1Src from '@images/marketing/PDPs/GITargetedPage-Carousel-1.jpg';
import giTargetedPDP2Src from '@images/marketing/PDPs/GITargetedPage-Carousel-2.jpg';
import sweetPotatoPDP1Src from '@images/marketing/PDPs/SweetPotatoPage-Carousel-1.jpg';
import sweetPotatoPDP2Src from '@images/marketing/PDPs/SweetPotatoPage-Carousel-2.jpg';
import sweetPotatoPDP3Src from '@images/marketing/PDPs/SweetPotatoPage-Carousel-3.jpg';
import beefBlueberryFreeSrc from '@images/marketing/product_cards/beef-blueberry-treats-7oz-free.png';
import blueberryBeefSrc from '@images/marketing/product_cards/beef-blueberry-treats-7oz.png';
import beefJerkyFreeSrc from '@images/marketing/product_cards/beef-jerky-treats-4oz-free.png';
import beefJerkySrc from '@images/marketing/product_cards/beef-jerky-treats-4oz.png';
import chickenCranberryFreeSrc from '@images/marketing/product_cards/chicken-cranberry-treats-7oz-free.png';
import cranberryChickenSrc from '@images/marketing/product_cards/chicken-cranberry-treats-7oz.png';
import chickenJerkyFreeSrc from '@images/marketing/product_cards/chicken-jerky-treats-4oz-free.png';
import chickenJerkySrc from '@images/marketing/product_cards/chicken-jerky-treats-4oz.png';
import fullSpectrumProbioticsSrc from '@images/marketing/product_cards/probiotic-dog-full-spectrum.png';
import giTargetedProbioticsSrc from '@images/marketing/product_cards/probiotic-dog-gi.png';
import sweetPotatoFreeSrc from '@images/marketing/product_cards/sweet-potato-treats-6oz-free.png';
import sweetPotatoSrc from '@images/marketing/product_cards/sweet-potato-treats-6oz.png';
var TreatName;
(function (TreatName) {
    TreatName["ChickenJerky"] = "chicken-jerky-treats-4oz";
    TreatName["BeefJerky"] = "beef-jerky-treats-4oz";
    TreatName["BeefBlueberry"] = "beef-blueberry-treats-7oz";
    TreatName["ChickenCranberry"] = "chicken-cranberry-treats-7oz";
    TreatName["SweetPotato"] = "sweet-potato-treats-6oz";
})(TreatName || (TreatName = {}));
// ensure the TreatName enum values are the shared corresponding treat names
TreatName;
var treatInfo = (_a = {},
    _a[TreatName.ChickenJerky] = {
        displayName: 'Chicken Jerky',
        get tileDisplayName() {
            return this.displayName;
        },
        slug: TreatName.ChickenJerky,
        ingredients: 'Our low-fat jerky is made with 100% lean chicken and nothing else. 4 oz.',
        fullIngredients: sharedTreatInfo[TreatName.ChickenJerky].ingredients,
        nutritionInfo: sharedTreatInfo[TreatName.ChickenJerky].nutritionInfo,
        price: 12.99,
        productId: TreatName.ChickenJerky,
        image: {
            src: chickenJerkySrc,
            alt: 'A bag of our Chicken Jerky',
        },
        pdpImages: [
            {
                src: chickenJerkyPDP1Src,
                alt: 'A pack of Chicken Jerky treats',
            },
            {
                src: chickenJerkyPDP2Src,
                alt: 'Some Chicken Jerky treats spread out in front of their packaging',
            },
            {
                src: chickenJerkyPDP3Src,
                alt: 'A dog being fed a Chicken Jerky treat by its owner',
            },
        ],
        isNew: false,
        url: "/other-products/treats/".concat(TreatName.ChickenJerky),
    },
    _a[TreatName.BeefJerky] = {
        displayName: 'Beef Jerky',
        get tileDisplayName() {
            return this.displayName;
        },
        slug: TreatName.BeefJerky,
        ingredients: 'Our protein-rich jerky is made with 100% beef and nothing else. 4 oz.',
        fullIngredients: sharedTreatInfo[TreatName.BeefJerky].ingredients,
        nutritionInfo: sharedTreatInfo[TreatName.BeefJerky].nutritionInfo,
        price: 14.99,
        productId: TreatName.BeefJerky,
        image: {
            src: beefJerkySrc,
            alt: 'A bag of our Beef Jerky',
        },
        pdpImages: [
            {
                src: beefJerkyPDP1Src,
                alt: 'A pack of Beef Jerky treats',
            },
            {
                src: beefJerkyPDP2Src,
                alt: 'Some Beef Jerky treats spread out in front of their packaging',
            },
            {
                src: beefJerkyPDP3Src,
                alt: 'A dog being fed a Beef Jerky treat by its owner',
            },
        ],
        isNew: false,
        url: "/other-products/treats/".concat(TreatName.BeefJerky),
    },
    _a[TreatName.BeefBlueberry] = {
        displayName: 'Wafers: Beef & Blueberry Flavor',
        get tileDisplayName() {
            return this.displayName;
        },
        slug: TreatName.BeefBlueberry,
        ingredients: 'Made with tender beef and nutritious blueberries. 7 oz.',
        fullIngredients: sharedTreatInfo[TreatName.BeefBlueberry].ingredients,
        nutritionInfo: sharedTreatInfo[TreatName.BeefBlueberry].nutritionInfo,
        price: 11.99,
        productId: TreatName.BeefBlueberry,
        image: {
            src: blueberryBeefSrc,
            alt: 'A bag of our Beef & Blueberry wafers',
        },
        pdpImages: [
            {
                src: beefBlueberryPDP1Src,
                alt: 'A pack of Beef & Blueberry Flavor Wafers',
            },
            {
                src: beefBlueberryPDP2Src,
                alt: 'Some Beef & Blueberry Flavor Wafers spread out in front of their packaging',
            },
            {
                src: beefBlueberryPDP3Src,
                alt: 'A dog being fed a Beef & Blueberry Flavor Wafer by its owner',
            },
        ],
        isNew: true,
        url: "/other-products/treats/".concat(TreatName.BeefBlueberry),
    },
    _a[TreatName.ChickenCranberry] = {
        displayName: 'Wafers: Chicken & Cranberry Flavor',
        get tileDisplayName() {
            return this.displayName;
        },
        slug: TreatName.ChickenCranberry,
        ingredients: 'Made with tender chicken and nutritious cranberries. 7 oz.',
        fullIngredients: sharedTreatInfo[TreatName.ChickenCranberry].ingredients,
        nutritionInfo: sharedTreatInfo[TreatName.ChickenCranberry].nutritionInfo,
        price: 11.99,
        productId: TreatName.ChickenCranberry,
        image: {
            src: cranberryChickenSrc,
            alt: 'A bag of our Chicken & Cranberry wafers',
        },
        pdpImages: [
            {
                src: chickenCranberryPDP1Src,
                alt: 'A pack of Chicken & Cranberry Flavor Wafers',
            },
            {
                src: chickenCranberryPDP2Src,
                alt: 'Some Chicken & Cranberry Flavor Wafers spread out in front of their packaging',
            },
            {
                src: chickenCranberryPDP3Src,
                alt: 'A dog being fed a Chicken & Cranberry Flavor Wafer by its owner',
            },
        ],
        isNew: true,
        url: "/other-products/treats/".concat(TreatName.ChickenCranberry),
    },
    _a[TreatName.SweetPotato] = {
        displayName: 'Sweet Potato Chews',
        get tileDisplayName() {
            return this.displayName;
        },
        slug: TreatName.SweetPotato,
        ingredients: 'These low-fat snacks are made with 100% sweet potato and nothing else. 6 oz.',
        fullIngredients: sharedTreatInfo[TreatName.SweetPotato].ingredients,
        nutritionInfo: sharedTreatInfo[TreatName.SweetPotato].nutritionInfo,
        price: 9.99,
        productId: TreatName.SweetPotato,
        image: {
            src: sweetPotatoSrc,
            alt: 'A bag of our Sweet Potato Chews',
        },
        pdpImages: [
            {
                src: sweetPotatoPDP1Src,
                alt: 'A pack of Sweet Potato Chews',
            },
            {
                src: sweetPotatoPDP2Src,
                alt: 'Some Sweet Potato Chews spread out in front of their packaging',
            },
            {
                src: sweetPotatoPDP3Src,
                alt: 'A dog being fed a Sweet Potato Chew by its owner',
            },
        ],
        isNew: true,
        url: "/other-products/treats/".concat(TreatName.SweetPotato),
    },
    _a);
var ProbioticName;
(function (ProbioticName) {
    ProbioticName["FullSpectrum"] = "probiotic-dog-full-spectrum";
    ProbioticName["GITargeted"] = "probiotic-dog-gi";
})(ProbioticName || (ProbioticName = {}));
// ensure the ProbioticName enum values are the shared corresponding probiotic names
ProbioticName;
var probioticInfo = (_b = {},
    _b[ProbioticName.FullSpectrum] = {
        displayName: 'Full Spectrum Probiotic Support',
        tileDisplayName: 'Full Spectrum Probiotic',
        isNew: false,
        slug: ProbioticName.FullSpectrum,
        ingredients: 'For all-around wellness and immune system function in dogs. 30-day supply.',
        price: 40,
        productId: ProbioticName.FullSpectrum,
        image: {
            src: fullSpectrumProbioticsSrc,
            alt: 'A bottle of Full Spectrum Probiotics',
        },
        pdpImages: [
            {
                src: fullSpectrumPDP1Src,
                alt: 'A container of Full Spectrum Probiotics',
            },
            {
                src: fullSpectrumPDP2Src,
                alt: 'A hand holding a Full Spectrum Probiotic container',
            },
        ],
        url: "/other-products/probiotics/".concat(ProbioticName.FullSpectrum),
    },
    _b[ProbioticName.GITargeted] = {
        displayName: 'GI-Targeted Probiotic Support',
        tileDisplayName: 'GI-Targeted Probiotic',
        isNew: false,
        slug: ProbioticName.GITargeted,
        ingredients: 'For a balanced microbiome and healthy digestion in dogs. 30-day supply.',
        price: 40,
        productId: ProbioticName.GITargeted,
        image: {
            src: giTargetedProbioticsSrc,
            alt: 'A bottle of GI-Targeted Probiotics',
        },
        pdpImages: [
            {
                src: giTargetedPDP1Src,
                alt: 'A container of GI-Targeted Probiotics',
            },
            {
                src: giTargetedPDP2Src,
                alt: 'A hand holding a GI-Targeted Probiotic container',
            },
        ],
        url: "/other-products/probiotics/".concat(ProbioticName.GITargeted),
    },
    _b);
var FreeProductName;
(function (FreeProductName) {
    FreeProductName["FreeChickenJerky"] = "chicken-jerky-treats-4oz-free";
    FreeProductName["FreeBeefJerky"] = "beef-jerky-treats-4oz-free";
    FreeProductName["FreeBeefBlueberry"] = "beef-blueberry-treats-7oz-free";
    FreeProductName["FreeChickenCranberry"] = "chicken-cranberry-treats-7oz-free";
    FreeProductName["FreeSweetPotato"] = "sweet-potato-treats-6oz-free";
})(FreeProductName || (FreeProductName = {}));
var freeProductInfo = (_c = {},
    _c[FreeProductName.FreeChickenJerky] = {
        displayName: 'Free - Chicken Jerky 4oz',
        tileDisplayName: 'Free Chicken Jerky Treats',
        slug: FreeProductName.FreeChickenJerky,
        ingredients: 'Our low-fat jerky is made with 100% lean chicken and nothing else. 4 oz.',
        fullIngredients: sharedTreatInfo[TreatName.ChickenJerky].ingredients,
        nutritionInfo: sharedTreatInfo[TreatName.ChickenJerky].nutritionInfo,
        price: 0,
        productId: FreeProductName.FreeChickenJerky,
        image: {
            src: chickenJerkyFreeSrc,
            alt: 'A bag of our Chicken Jerky',
        },
        pdpImages: [
            {
                src: chickenJerkyFreeSrc,
                alt: 'A bag of Chicken Jerky treats',
            },
        ],
        isNew: false,
        url: "/other-products/treats/".concat(FreeProductName.FreeChickenJerky),
    },
    _c[FreeProductName.FreeBeefJerky] = {
        displayName: 'Free - Beef Jerky 4oz',
        tileDisplayName: 'Free Beef Jerky Treats',
        slug: FreeProductName.FreeBeefJerky,
        ingredients: 'Our protein-rich jerky is made with 100% beef and nothing else. 4 oz.',
        fullIngredients: sharedTreatInfo[TreatName.BeefJerky].ingredients,
        nutritionInfo: sharedTreatInfo[TreatName.BeefJerky].nutritionInfo,
        price: 0,
        productId: FreeProductName.FreeBeefJerky,
        image: {
            src: beefJerkyFreeSrc,
            alt: 'A bag of our Beef Jerky',
        },
        pdpImages: [
            {
                src: beefJerkyFreeSrc,
                alt: 'A bag of Beef Jerky treats',
            },
        ],
        isNew: false,
        url: "/other-products/treats/".concat(FreeProductName.FreeBeefJerky),
    },
    _c[FreeProductName.FreeBeefBlueberry] = {
        displayName: 'Free - Beef and Blueberry Wafers 7oz',
        tileDisplayName: 'Free Beef and Blueberry Wafers',
        slug: FreeProductName.FreeBeefBlueberry,
        ingredients: 'Made with quality meat and fruit. A good source of fiber. Prepared in the USA. 7 oz bag.',
        fullIngredients: sharedTreatInfo[TreatName.BeefBlueberry].ingredients,
        nutritionInfo: sharedTreatInfo[TreatName.BeefBlueberry].nutritionInfo,
        price: 0,
        productId: FreeProductName.FreeBeefBlueberry,
        image: {
            src: beefBlueberryFreeSrc,
            alt: 'A bag of Beef and Blueberry Wafers',
        },
        pdpImages: [
            {
                src: beefBlueberryFreeSrc,
                alt: 'A bag of Beef and Blueberry Wafers',
            },
        ],
        isNew: false,
        url: "/other-products/treats/".concat(FreeProductName.FreeBeefBlueberry),
    },
    _c[FreeProductName.FreeChickenCranberry] = {
        displayName: 'Free - Chicken and Cranberry Wafers 7oz',
        tileDisplayName: 'Free Chicken and Cranberry Wafers',
        slug: FreeProductName.FreeChickenCranberry,
        ingredients: 'Made with quality meat and fruit. A good source of fiber. Prepared in the USA. 7 oz bag.',
        fullIngredients: sharedTreatInfo[TreatName.ChickenCranberry].ingredients,
        nutritionInfo: sharedTreatInfo[TreatName.ChickenCranberry].nutritionInfo,
        price: 0,
        productId: FreeProductName.FreeChickenCranberry,
        image: {
            src: chickenCranberryFreeSrc,
            alt: 'A bag of Chicken and Cranberry Wafers',
        },
        pdpImages: [
            {
                src: chickenCranberryFreeSrc,
                alt: 'A bag of Chicken and Cranberry Wafers',
            },
        ],
        isNew: false,
        url: "/other-products/treats/".concat(FreeProductName.FreeChickenCranberry),
    },
    _c[FreeProductName.FreeSweetPotato] = {
        displayName: 'Free - Sweet Potato Chews 6oz',
        tileDisplayName: 'Free Sweet Potato Chews',
        slug: FreeProductName.FreeSweetPotato,
        ingredients: '100% sweet potatoes. No preservatives or artificial flavors. Prepared in the USA. 6 oz bag.',
        fullIngredients: sharedTreatInfo[TreatName.SweetPotato].ingredients,
        nutritionInfo: sharedTreatInfo[TreatName.SweetPotato].nutritionInfo,
        price: 0,
        productId: FreeProductName.FreeSweetPotato,
        image: {
            src: sweetPotatoFreeSrc,
            alt: 'A bag of our Sweet Potato Chews',
        },
        pdpImages: [
            {
                src: sweetPotatoFreeSrc,
                alt: 'A bag of Sweet Potato Chews',
            },
        ],
        isNew: false,
        url: "/other-products/treats/".concat(FreeProductName.FreeSweetPotato),
    },
    _c);
export { treatInfo, probioticInfo, freeProductInfo, TreatName, ProbioticName, FreeProductName };
